// extracted by mini-css-extract-plugin
export default {"genericSelect":"GenericStyles_genericSelect__6a6zw","GenericButton":"GenericStyles_GenericButton__Zi324"};